<ion-header>
  <ion-toolbar>
    <!--ion-buttons left>
      <button ion-button icon-only (tap)="onDismiss()">
        <ion-icon name="close"></ion-icon>
      </button>
    </ion-buttons-->
    <ion-title>
      Tip
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">

  <div *ngIf="paymentFromTerminalSuccess" class="ion-text-center">
    <h4>Payment Success</h4>

    <!-- <span>Payment received: {{ paymentReceived | salonMonsterCurrency }}</span> -->

    <div *ngIf="tipsReceived > 0">
      <span>Tips received: {{ tipsReceived | salonMonsterCurrency }}</span>

      <smr-stylist-picker
        (onInit)="onStylistPickerInit($event)"
        (stylistSelect)="onStylistSelect($event)"
        cssClass="smr-stylist-picker-for-tips"
        >
      </smr-stylist-picker>
    </div>

    <ion-button expand="block" (click)="onDismiss()">Close</ion-button>
  </div>
  
  <ng-container *ngIf="!paymentFromTerminalSuccess">
    <ng-container *ngIf="!anErrorOccurred">
      <div class="ion-text-center ion-margin-top">
        
        <div *ngIf="isConnecting"> 
          <h4>Establishing connection to your terminal...</h4>
          <ion-button color="dark" fill="clear" (click)="disconnect()">Cancel</ion-button>
          <div clas="ion-text-center">
            <div class="pulsate-css"></div>
          </div>
        </div>

        <div *ngIf="!isConnecting">
          <h4>Successfully connected to your terminal. 🎉</h4> 
          <ion-note>Please review the amount and ask the customer to complete the transaction by inserting/swiping his/her card. 💳</ion-note>
          <br/>
          <ion-button color="dark" fill="clear" (click)="disconnect()">Cancel</ion-button>
          <div>
            <img class="sm-card-terminal-image" src="./assets/images/vector-card-reader-illustration.jpg">
          </div>
        </div>

      </div>
    </ng-container>

    <div *ngIf="anErrorOccurred" class="ion-padding ion-text-center">
      <h4>Can't establish a reliable connection to the terminal.</h4>
      <ul>
        <li>1) Check your internet connection.</li>
        <li>2) Make sure that the terminal is powered on and connected to the internet.</li>
        <li>3) Make sure your terminal credentials are correct.</li>
      </ul>
    
      <div class="ion-text-center">
        <ion-button fill="clear" color="dark" (click)="onDismiss()">Cancel</ion-button>
      
        <ion-button fill="clear" color="primary" (click)="connect()">Re-try</ion-button>
      </div>
    </div>
  </ng-container>
  
</ion-content>
